import {
  Property,
  PropertyArea,
  PropertyAreaStoreRequestPayload,
  PropertyAreaUpdateRequestPayload,
  PropertyStoreRequestPayload,
  PropertyUpdate,
} from "../types/property";

import ApiService from "./ApiService";

interface PropertyQueryParams {
  "filter[customerId]"?: string;
}

type GetPropertyAreaResponse = {
  data: PropertyArea;
};

type CreatePropertyAreaResponse = {
  data: PropertyArea;
};

type GetPropertyRespose = {
  data: Property;
  includes: any;
};

type GetPropertiesRespose = {
  data: Property[];
  includes: any;
};

type CreatePropertyResponse = {
  data: Property;
};

const PropertyService = {
  GetProperty: async (propertyId: string): Promise<GetPropertyRespose> => {
    return ApiService.Get(`properties/${propertyId}`, {
      include: "propertyAreas.monitors.traplinkedReports,documents",
    });
  },

  GetProperties: async (
    params: PropertyQueryParams
  ): Promise<GetPropertiesRespose> => {
    return ApiService.Get(`properties`, { ...params });
  },

  GetPropertyDeficiencies: async (
    propertyId: string
  ): Promise<GetPropertyRespose> => {
    return ApiService.Get(`properties/${propertyId}`, {
      include: "deficiencies,deficiencies.comments",
    });
  },

  CreateProperty: async (
    data: PropertyStoreRequestPayload
  ): Promise<CreatePropertyResponse> => {
    return ApiService.Post("properties", data);
  },

  UpdateProperty: async (
    propertyId: string,
    data: Partial<PropertyUpdate>
  ): Promise<CreatePropertyResponse> => {
    return ApiService.Patch(`properties/${propertyId}`, data);
  },

  GetPropertyArea: async (
    propertyAreaId: string
  ): Promise<GetPropertyAreaResponse> => {
    return ApiService.Get(`property-areas/${propertyAreaId}`);
  },

  CreatePropertyArea: async (
    data: PropertyAreaStoreRequestPayload
  ): Promise<CreatePropertyAreaResponse> => {
    return ApiService.Post("property-areas", data);
  },

  UpdatePropertyArea: async (
    id: string,
    data: PropertyAreaUpdateRequestPayload
  ): Promise<CreatePropertyAreaResponse> => {
    return ApiService.Update(id, "property-areas", data);
  },

  GetPropertyAccessibleUsers: async (propertyId: string): Promise<any> => {
    return ApiService.Get(`properties/${propertyId}/accessible-users`);
  },

  GetPropertyMonitorTypes: async (propertyId: string): Promise<any> => {
    return ApiService.Get(`properties/${propertyId}/monitor-types`);
  },

  ToggleHidden: async (propertyAreaId: string): Promise<any> => {
    return ApiService.Patch(
      `property-areas/${propertyAreaId}/toggle-hidden`,
      {}
    );
  },
};

export default PropertyService;
